<template>
    <div class="form-group">
        <label class="form-label section-title">{{ title }}</label>
        <div class="toggle-buttons">
            <button v-for="opt in options" :key="opt.value" :class="['toggle-btn', { active: opt.value === value }]"
                @click="select(opt.value)">{{ opt.label }}</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "DayDistribution",
    props: {
        value: {
            type: String,
            default: 'evenly'
        },
        title: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        select(val) {
            this.$emit('update', val);
        }
    }
};
</script>

<style scoped>
.toggle-buttons {
    display: flex;
    gap: 8px;
}

.toggle-btn {
    padding: 8px 12px;
    border-radius: 4px;
    background: #fff;
    border: 1px solid #e9ecef;
    cursor: pointer;
}

.toggle-btn.active {
    background: #ec4899;
    color: white;
}
</style>

